import { DateTime } from 'luxon';

/**
 * Formata uma data para o formato brasileiro (dd/MM/yyyy)
 * @param {Date|string} date - Data a ser formatada
 * @returns {string} - Data formatada
 */
export const formatDateBR = (date) => {
  if (!date) return '';
  return DateTime.fromISO(date).toFormat('dd/MM/yyyy');
};

/**
 * Formata uma data e hora para o formato brasileiro (dd/MM/yyyy HH:mm)
 * @param {Date|string} date - Data a ser formatada
 * @returns {string} - Data e hora formatadas
 */
export const formatDateTimeBR = (date) => {
  if (!date) return '';
  return DateTime.fromISO(date).toFormat('dd/MM/yyyy HH:mm');
};

/**
 * Formata uma hora para o formato HH:mm
 * @param {string} time - Hora a ser formatada
 * @returns {string} - Hora formatada
 */
export const formatTime = (time) => {
  if (!time) return '';
  return time.substring(0, 5);
};

/**
 * Converte uma data do formato brasileiro para ISO (yyyy-MM-dd)
 * @param {string} date - Data no formato dd/MM/yyyy
 * @returns {string} - Data no formato ISO
 */
export const dateToISO = (date) => {
  if (!date) return '';
  const [day, month, year] = date.split('/');
  return `${year}-${month}-${day}`;
};

/**
 * Verifica se uma data é válida
 * @param {string} date - Data a ser validada
 * @returns {boolean} - true se a data é válida
 */
export const isValidDate = (date) => {
  if (!date) return false;
  const dt = DateTime.fromISO(date);
  return dt.isValid;
};

/**
 * Retorna a data atual no formato ISO
 * @returns {string} - Data atual no formato ISO
 */
export const getCurrentDate = () => {
  return DateTime.now().toISODate();
};

/**
 * Retorna a hora atual no formato HH:mm
 * @returns {string} - Hora atual
 */
export const getCurrentTime = () => {
  return DateTime.now().toFormat('HH:mm');
};



